import React, { useEffect, useState } from '../_snowpack/pkg/react.js';
import { observer } from '../_snowpack/pkg/mobx-react-lite.js';
import { Filter, ReactTable } from './components/index.js';
import { useStore } from './stores/index.js';
import { jsx as __cssprop } from "../_snowpack/pkg/@emotion/react.js";
const AppObserver = observer(function App() {
  const store = useStore();
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  // Check if current route contains /ThermalStep/ (case-insensitive)
  const isThermalStepRoute = currentPath.toLowerCase().includes('/thermalstep/');

  // Listen for navigation changes
  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(window.location.pathname);
    };

    // Listen for browser back/forward navigation
    window.addEventListener('popstate', handlePopState);

    // Also check for programmatic navigation changes
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;
    history.pushState = function (...args) {
      originalPushState.apply(history, args);
      setCurrentPath(window.location.pathname);
    };
    history.replaceState = function (...args) {
      originalReplaceState.apply(history, args);
      setCurrentPath(window.location.pathname);
    };
    return () => {
      window.removeEventListener('popstate', handlePopState);
      history.pushState = originalPushState;
      history.replaceState = originalReplaceState;
    };
  }, []);

  // Set default loaded state for ThermalStep route
  useEffect(() => {
    if (isThermalStepRoute) {
      store.init();
    }
  }, [isThermalStepRoute]);

  // Return empty if not on ThermalStep route
  if (!isThermalStepRoute) {
    return null;
  }
  return __cssprop(React.Fragment, null, __cssprop(Filter, null), __cssprop(ReactTable, null));
});

// Expose the observer with load trigger
export default AppObserver;
export { AppObserver as observer };